import { BooleanInput, coerceBooleanProperty } from '@angular/cdk/coercion';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { CuttingPanelHelper } from '../../../helpers/cutting-panel.helper';

@Component({
  selector: 'csl-inside-cut-with-angle-input',
  templateUrl: './inside-cut-with-angle-input.component.html',
})
export class InsideCutWithAngleInputComponent {
  _X = 0;
  _Y = 0;
  _X1 = 0;
  _Y1 = 0;
  _XA = 90;
  _YA = 90;
  _R = 0;

  mode: 'angle' | 'side' = 'angle';

  paramsCalcError = '';

  variableParamsChanged$: Observable<unknown>;

  @Input() editable = true;

  @Input() xMax = 0;
  @Input() xMin = 0;
  @Input() yMax = 0;
  @Input() yMin = 0;
  @Input() rMax = 0;
  @Input() rMin = 0;

  @Output() xChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() set x(value: number) {
    this._X = value;
  }

  @Output() yChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() set y(value: number) {
    this._Y = value;
  }

  @Output() xAChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() set xA(value: number) {
    this._XA = value;
  }

  @Output() yAChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() set yA(value: number) {
    this._YA = value;
  }

  @Output() x1Change: EventEmitter<number> = new EventEmitter<number>();
  @Input() set x1(value: number) {
    this._X1 = value;
  }

  @Output() y1Change: EventEmitter<number> = new EventEmitter<number>();
  @Input() set y1(value: number) {
    this._Y1 = value;
  }

  @Output() rChange: EventEmitter<number> = new EventEmitter<number>();
  @Input() set r(value: number) {
    this._R = value;
  }

  @Input()
  get dense() {
    return this._dense;
  }
  set dense(value: BooleanInput) {
    this._dense = coerceBooleanProperty(value);
  }
  _dense = false;

  recalculateVariableParams(): void {
    this.paramsCalcError = '';
    const calculatedNumberPrecision = 3;

    try {
      if (this.isSideMode()) {
        const angles = CuttingPanelHelper.insideCut.findAngles(this._X, this._Y, this._X1, this._Y1);
        this._XA = _.round(angles.XA, calculatedNumberPrecision);
        this._YA = _.round(angles.YA, calculatedNumberPrecision);
        this.xAChange.emit(this._XA);
        this.yAChange.emit(this._YA);
      } else {
        const angles = CuttingPanelHelper.insideCut.findSubSides(this._X, this._Y, this._XA, this._YA);

        this._X1 = _.round(angles.x1, calculatedNumberPrecision);
        this._Y1 = _.round(angles.y1, calculatedNumberPrecision);
        this.x1Change.emit(this._X1);
        this.y1Change.emit(this._Y1);
      }

      if (this.xMin > this._X1 || this._X1 > this.xMax || this.yMin > this._Y1 || this._Y1 > this.yMax) {
        throw new Error($localize`Точка пересечения сторон обработки угла за пределами панели`);
      }
    } catch (e) {
      if (e instanceof Error) {
        this.paramsCalcError = e.message;
      }
    }
  }

  paramChanged(eventEmitter: EventEmitter<number>, param: 'XA' | 'YA' | 'X1' | 'Y1' | 'R' | 'X' | 'Y', value: number) {
    this[`_${param}`] = value;

    eventEmitter.next(value);

    if (param !== 'R') {
      this.recalculateVariableParams();
    }
  }

  isSideMode(): boolean {
    return this.mode === 'side';
  }
}
